
import { defineComponent, ref, Ref, onMounted, onUnmounted } from "vue";
import TouchControl from "@/components/TouchControl.vue";
import StatusBar from "@/components/StatusBar.vue";
import Settings from "@/components/Settings.vue";
import { Game, TLevel } from "@/game";
import { useUserLevel } from "@/hooks/use-user-level";

export default defineComponent({
  name: "GamePage",
  components: { Settings, StatusBar, TouchControl },
  setup() {
    let game: Game | null = null;

    const canvas: Ref<HTMLCanvasElement | null> = ref(null);
    const levels: Ref<TLevel[]> = ref([]);
    const scores = ref(0);
    const isPlaying = ref(false);
    const isPaused = ref(false);
    const { userLevel } = useUserLevel();

    const start = (speed: number, level: number) => {
      if (game)
        game.restart({
          speed,
          level,
        });
    };

    const pause = () => {
      if (game) {
        game.pause();
        isPaused.value = true;
      }
    };

    const resume = () => {
      if (game) {
        game.resume();
        isPaused.value = false;
      }
    };

    onMounted(() => {
      game = new Game(canvas.value as HTMLCanvasElement, {
        userLevel: userLevel.value,
      });

      levels.value = game.getLevelsList();

      game.onChangeScores = (_scores) => {
        scores.value = _scores;
      };

      game.onRestart = () => {
        isPaused.value = false;
        isPlaying.value = true;
      };

      game.onStop = () => {
        isPlaying.value = false;
      };
    });

    onUnmounted(() => {
      if (game) game.stop();
    });

    return {
      canvas,
      scores,
      levels,
      isPlaying,
      isPaused,
      start,
      pause,
      resume,
    };
  },
});
